<template>
    <div class="container--large-content">
        <div class="container">
            <h2>{{ $t('cycle-life-title') }}</h2>

            <p
                class="page__subtitle"
                v-html="$t('cycle-life-subtitle')"></p>
            
        </div>

        <template v-if="yearCycle">
            <BalloonChart
                :user-birthdate="userBirthDate"
                @year-clicked="handleYearClicked"
                :data="yearCycle" 
                @show-domain-modal="showDomainModal"/>

            <!-- <div class="container">

                
                <ul class="list--unstyled list--legend">
                    <li class="list--legend__item">
                        <span class="circle circle--fire"></span>
                        <span>{{ $t("legend-cycle_fire") }}</span>
                    </li>
                    <li class="list--legend__item">
                        <span class="circle circle--earth"></span>
                        {{ $t("legend-cycle_earth") }}
                    </li>
                    <li class="list--legend__item">
                        <span class="circle circle--air"></span>
                        {{ $t("legend-cycle_air") }}
                    </li>
                    <li class="list--legend__item">
                        <span class="circle circle--water"></span>
                        {{ $t("legend-cycle_water") }}
                    </li>
                </ul>
            </div> -->
        </template>    

        <template v-if="yearCycle">
            <BalloonChart
                :user-birthdate="userBirthDate"
                @year-clicked="handleYearClicked"
                :data="yearCycle2" />
        </template>

        <!-- <template v-if="yearCycle">
            <BalloonChart
                :user-birthdate="userBirthDate"
                @year-clicked="handleYearClicked"
                :data="yearCycle3" />
        </template> -->
        


        <template v-else>
            <div class="loader">
                <HorizontalBubbleLoader />
            </div>
        </template>

        <domain-detail-modal
            v-if="isDomainModalVisible"
            :current-domain-detail="domain"
            @closeModal="isDomainModalVisible = false" />
    </div>
</template>

<script>
// @ is an alias to /src

import BalloonChart from "@/components/charts/BalloonChart.vue";

import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";
import DomainDetailModal from "@/components/modals/domains/DomainDetailModal.vue";

import dayjs from "dayjs";

export default {
    name: "CycleLife",
    components: {
        "BalloonChart": BalloonChart,
        "HorizontalBubbleLoader": HorizontalBubbleLoader,
        "DomainDetailModal": DomainDetailModal
    },
    props: {
        cycle: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            fetchCycleTentative: 0,
            currentYearDetail: null,
            currentDomainDetail: null,
            isDomainModalVisible: false,
            currentPeriodType: "year"
        };
    },
    computed: {
        // loggedUser
        // Current logged user
        loggedUser() {
            return this.$store.getters["userModule/getUser"];
        },
        userBirthDate() {
            if (this.loggedUser) {
                return this.loggedUser.bdate;
            }
        },
        yearCycle() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    return item.report_name === "cycle";
                });
            }
        },
        yearCycle2() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    return item.report_name === "cycle2";
                });
            }
        },
        /*yearCycle3() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    return item.report_name === "cycle3";
                });
            }
        },*/
    },
    mounted: function() {
    },
    methods: {
        handleYearClicked(iday, year, domain) {
            this.$emit("year-clicked", iday, year, domain);
        },
        showDomainModal(value) {
            this.currentDomainDetail = {
                "title": this.$t(this.value),
                "description": this.$t(this.value)
            };

            this.isDomainModalVisible = true;
        }
    }
};
</script>

